interface UmbrellaFilters {
  page?: number
  pageSize?: number
}

export const defaultQuery: UmbrellaFilters = {
  page: undefined,
  pageSize: undefined,
}
